import { FC, useState } from "react";
import { Button, IconButton, Paper, Tooltip } from "@mui/material";
import EditLocationAltIcon from "@mui/icons-material/EditLocationAlt";
import EventLocationPointModal from "../event-location-point-modal";

interface MapLocationPointProps {
  props: {
    id: string;
    isEdit: boolean;
    isReadOnly: boolean;
    geometry: GeoJSON.Geometry | undefined;
    handleInputChange: (e: any, field: string) => void;
  };
}
const MapLocationPoint: FC<MapLocationPointProps> = ({ props }) => {
  const [isMapModalOpen, setIsMapModalOpen] = useState(false);

  return (
    <Paper variant="outlined" style={{ padding: "8px" }}>
      Map location is {props.geometry?.type === "Point" ? "set." : "not set."}
      <Tooltip
        title={props.isReadOnly ? "" : `${
          !props.isEdit ? "Click edit button below, then click this" : "Click"
        } to view, set or update location on map`}
      >
        {/* Use span so Tooltip works even when icon is disabled */}
        <span>
          <IconButton
            disabled={!props.isEdit}
            onClick={() => {
              setIsMapModalOpen(true);
            }}
          >
            <EditLocationAltIcon />
          </IconButton>
        </span>
      </Tooltip>
      {props.isEdit && props.geometry?.type === "Point" && (
        <Button
          color="inherit"
          variant="contained"
          onClick={() => {
            props.handleInputChange(undefined, props.id);
          }}
        >
          Clear Map Location
        </Button>
      )}
      {isMapModalOpen && (
        <EventLocationPointModal
          props={{
            isOpen: isMapModalOpen,
            initialLngLat: (props.geometry as GeoJSON.Point)
              ? {
                  lng: (props.geometry as GeoJSON.Point)?.coordinates[0],
                  lat: (props.geometry as GeoJSON.Point)?.coordinates[1],
                }
              : undefined,
            onCancel: () => {
              setIsMapModalOpen(false);
            },
            onConfirm: (newLongitude: number, newLatitude: number) => {
              props.handleInputChange(
                { type: "Point", coordinates: [newLongitude, newLatitude] } as GeoJSON.Point,
                props.id,
              );
              setIsMapModalOpen(false);
            },
          }}
        />
      )}
    </Paper>
  );
};

export default MapLocationPoint;
